import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "team-divider",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./divider.component.html",
  styleUrls: ["./divider.component.scss"],
})
export class DividerComponent {}
